import React, { useState } from 'react';
import { connect } from 'react-redux';

import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

import Header from './Header';
import Footer from './Footer';
import SideNavBar from './sideNavBar';

const MainContent = styled(Box)({
  display: 'flex',
  width: '100%',
  height: 'calc(100vh - 70px - 50px)',
  background: '#F0F0F0',
  overflow: 'hidden',
});

const LeftSection = styled(Box)<{ isExpanded: boolean }>(({ isExpanded }) => ({
  width: isExpanded ? '18rem' : '5%',
  boxShadow: '0px 4px 4px 0px #0000001A',
  background: '#FFFFFF',
  zIndex: 1,
  transition: 'width 0.1s ease-in-out',
}));

const RightSection = styled(Box)<{ isExpanded: boolean; isLoggedIn: boolean }>(
  ({ isExpanded, isLoggedIn }) => ({
    width: !isLoggedIn ? '100%' : isExpanded ? '84%' : '95%',
    overflow: 'auto',
  })
);

const AppLayout = (props: any) => {
  const [childState, setChildState] = useState(true);

  // Callback function to update state in parent
  const updateStateFromChild = (newState: boolean) => {
    setChildState(newState);
  };

  return (
    <>
      <div>
        <Header />
      </div>
      <MainContent>
        {props.isLoggedIn && (
          <LeftSection isExpanded={childState}>
            <SideNavBar updateParentState={updateStateFromChild} />
          </LeftSection>
        )}
        <RightSection isExpanded={childState} isLoggedIn={props.isLoggedIn}>
          {props.children}
        </RightSection>
      </MainContent>
      <div>
        <Footer />
      </div>
    </>
  );
};

function mapStateToProps(state: any) {
  return {
    isLoggedIn: state.user.isLoggedIn,
  };
}

export default connect(mapStateToProps)(AppLayout);
